import { get, catchActionErrors, throwActionErrors} from '../../utils/actions';

export function getRecordings(stream: string) {
  return get(`/api/streams/${stream}/recordings`)
    .then(throwActionErrors)
    .then(response => {
      return response.json();
    })
    .catch(catchActionErrors);
}